<template>
    <TinyMceEditor :api-key="apiKey"
                   :init="editorOptions"
                   tinymce-script-src="https://cdn.portofportland.com/tinymce/5.10.9/tinymce.min.js">
    </TinyMceEditor>
</template>

<script setup>
    import TinyMceEditor from '@tinymce/tinymce-vue';
    import { computed, onMounted, ref } from 'vue';

    const props = defineProps({
        options: {
            type: Object,
            default: {}
        }
    });

    const apiKey = ref('1itcvmlrwpdnz8nx497q2qar5ji9lnurniyaisciqs4em2ei');

    const editorOptions = computed(() => {
        let defaultOptions = {
            toolbar: 'link unlink anchor | bold italic strikethrough removeformat | blocks | numlist bullist | outdent indent blockquote | alignleft aligncenter alignright alignjustify | code | fullscreen',
            plugins: 'anchor code fullscreen link lists',
            menubar: '',
            skin: 'oxide-dark',
            paste_data_images: false
        };
        return { ...defaultOptions, ...props.options };
    });

    onMounted(() => {
        // fix for insert link and source code popups not allowing focus when the editor is in a modal window
        document.addEventListener('focusin', (e) => {
            if (e.target.closest(".tox-tinymce-aux, .moxman-window, .tam-assetmanager-root") !== null) {
                e.stopImmediatePropagation();
            }
        });
    });

</script>